module.exports = __webpack_public_path__ + "6260d578e994d987ac91d64ed810884a.svg";